import React, { useEffect } from 'react';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { BulkOperationsToolbarSkeleton } from '@atlassian/jira-bulk-operations-core/src/ui/toolbar/bulk-operations-toolbar-skeleton';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import type { EntryPointReferenceSubject } from '@atlassian/jira-entry-point/src/controllers/utils/use-entry-point-load-manager/index.tsx';
import type { ToolbarAction } from '@atlassian/jira-floating-toolbar/src/common/types.tsx';
import { ToolbarWrapper } from '@atlassian/jira-floating-toolbar/src/ui/toolbar-wrapper';
import { asyncBulkOpsCoreEntryPoint } from '../entrypoint';
import type { BulkOpsCoreType } from './ui';

const entryPointParams = {};
export const AsyncBulkOpsCore = (props: BulkOpsCoreType) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		asyncBulkOpsCoreEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="jira.backlog.bulk.operations.core"
			packageName="jiraBulkOperationsCore"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<></>}
			runtimeProps={props}
		/>
	);
};

type BulkOpsCoreWithToolbarProps = BulkOpsCoreType & {
	extraToolbarButtons?: ToolbarAction[];
	bulkopsCoreEntryPointReference?: // remove ? on bulk_operations_floating_toolbar cleanup
	| EntryPointReferenceSubject<EntryPoint<EntryPointComponent<{}, {}, BulkOpsCoreType, {}>, {}>>
		| undefined;
};

export const BulkOpsCoreWithToolbar = ({
	bulkopsCoreEntryPointReference,
	...props
}: BulkOpsCoreWithToolbarProps) => {
	const hasSelectAllButton = Boolean(props.onSelectAll);
	const extraToolbarButtonsSkeleton =
		props.extraToolbarButtons?.map((button) => ({
			hasIcon: Boolean(button.icon),
			text: button.name,
		})) || [];

	return (
		<ToolbarWrapper
			show={props.selectedIssueIds.length > 0}
			width="calc(100% - var(--leftSidebarWidth, 0px))"
		>
			{bulkopsCoreEntryPointReference && (
				<JiraEntryPointContainer
					id="jiraAsyncBulkOperationsCoreWithToolBar"
					packageName="jiraBulkOperationsCoreWithToolBar"
					teamName="deliveroo"
					entryPointReferenceSubject={bulkopsCoreEntryPointReference}
					fallback={
						<BulkOperationsToolbarSkeleton
							buttons={extraToolbarButtonsSkeleton}
							hasSelectAllButton={hasSelectAllButton}
						/>
					}
					runtimeProps={props}
				/>
			)}
		</ToolbarWrapper>
	);
};
